import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Asset property property - Definition */
export class DocsBlockAssetPropertyPropertyDefinition extends DocsBlockPropertyDefinition {
}
